<ng-container *ngFor="let item of items; let i = index; first as isFirst">
  <ng-container [ngSwitch]="item.type">
    <ng-container *ngSwitchCase="MenuItemType.LINK">
      <ng-container [ngTemplateOutlet]="link" [ngTemplateOutletContext]="{ item, isFirst }"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="MenuItemType.TOGGLE">
      <ng-container [ngTemplateOutlet]="toggle" [ngTemplateOutletContext]="{ item, isFirst }"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="MenuItemType.SIDEPANEL">
      <ng-container
        [ngTemplateOutlet]="sidepanel"
        [ngTemplateOutletContext]="{ item, isFirst, prevItem: items[i - 1], nextItem: items[i + 1] }"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="MenuItemType.BUTTONSET">
      <ng-container [ngTemplateOutlet]="buttonset" [ngTemplateOutletContext]="{ item, isFirst }"></ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container [ngTemplateOutlet]="default" [ngTemplateOutletContext]="{ item, isFirst }"></ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #link let-item="item">
  <a
    *ngIf="!item.disabled && item.typeOptions.url | decodeUrl as url"
    pButton
    [type]="buttonType"
    class="no-underline"
    [ngClass]="{
      'p-button-link w-full justify-start p-2': buttonType === 'link',
      'p-button-sm': buttonType === 'button',
      'p-button-outlined': item.outlined && buttonType === 'button'
    }"
    [class]="itemClass"
    [target]="item.typeOptions.target"
    [routerLink]="url.segments"
    [queryParams]="url.queryParams"
    [attr.aria-labelledby]="buttonContent">
    <ng-container [ngTemplateOutlet]="buttonContent" [ngTemplateOutletContext]="{ item }"></ng-container>
  </a>
  <button
    *ngIf="item.disabled"
    pButton
    [type]="buttonType"
    class="no-underline"
    [ngClass]="{
      'p-button-link w-full justify-start p-2': buttonType === 'link',
      'p-button-sm': buttonType === 'button',
      'p-button-outlined': item.outlined && buttonType === 'button'
    }"
    [class]="itemClass"
    [target]="item.typeOptions.target"
    [disabled]="true"
    [routerLink]="item.typeOptions.url"
    [attr.aria-labelledby]="buttonContent">
    <ng-container [ngTemplateOutlet]="buttonContent" [ngTemplateOutletContext]="{ item }"></ng-container>
  </button>
</ng-template>
<ng-template #sidepanel let-item="item" let-prevItem="prevItem" let-nextItem="nextItem">
  <div
    class="bg-gray-200"
    [ngClass]="{
      'rounded-t-lg': prevItem?.type !== MenuItemType.SIDEPANEL,
      'rounded-b-lg': nextItem?.type !== MenuItemType.SIDEPANEL
    }">
    <button
      pButton
      type="button"
      class="no-underline"
      [ngClass]="{
        'p-button-link w-full justify-start p-2': buttonType === 'link',
        'p-button-sm': buttonType === 'button',
        'p-button-outlined': item.outlined && buttonType === 'button'
      }"
      [class]="itemClass"
      [disabled]="item.disabled"
      (click)="itemClick.emit(item)"
      (keydown.space)="$event.preventDefault(); itemClick.emit(item)"></button>
  </div>
</ng-template>
<ng-template #buttonset let-item="item" let-isFirst="isFirst">
  <app-detail-action-buttons
    class="p-buttonset flex"
    [itemClass]="itemClass"
    [buttonType]="'button'"
    [checkedItems]="checkedItems"
    [items]="item.typeOptions.actions"
    (itemClick)="itemClick.emit($event)"
    (endAction)="endAction.emit(item)"></app-detail-action-buttons>
</ng-template>
<ng-template #toggle let-item="item">
  <app-detail-action-button-toggle
    [checkedItems]="checkedItems"
    [item]="item"
    class="text-left"
    (endAction)="endAction.emit(item)"></app-detail-action-button-toggle>
</ng-template>
<ng-template #default let-item="item" let-isFirst="isFirst">
  @if (itemShouldBeDisabled(item)) {
    <span [title]="'agenda.action.disabled' | translate" style="display: inline-block" tabindex="0">
      <ng-container
        [ngTemplateOutlet]="defaultButton"
        [ngTemplateOutletContext]="{ item, isFirst, disabled: true }"></ng-container>
    </span>
  } @else {
    <ng-container
      [ngTemplateOutlet]="defaultButton"
      [ngTemplateOutletContext]="{ item, isFirst, disabled: false }"></ng-container>
  }
</ng-template>

<ng-template #defaultButton let-item="item" let-disabled="disabled">
  <button
    pButton
    type="button"
    class="no-underline"
    [class]="itemClass"
    [ngClass]="{
      'p-button-link w-full justify-start p-2': buttonType === 'link',
      'p-button-sm': buttonType === 'button',
      'p-button-outlined': item.outlined && buttonType === 'button'
    }"
    [disabled]="disabled"
    (click)="itemClick.emit(item)"
    (keydown.space)="$event.preventDefault(); itemClick.emit(item)"
    [attr.aria-labelledby]="buttonContent">
    <ng-container [ngTemplateOutlet]="buttonContent" [ngTemplateOutletContext]="{ item }"></ng-container>
  </button>
</ng-template>

<ng-template #buttonContent let-item="item">
  <span *ngIf="item.icon" class="p-button-icon p-button-icon-left" [class]="item.icon" aria-hidden="true"></span>
  <span *ngIf="item.name" class="p-button-label w-full text-left">{{ item.name | translate }}</span>
  <p-badge *ngIf="item.count" class="p-badge-xs" [value]="item.count"></p-badge>
</ng-template>
